/**
 * Mega Menu Delay Enhancement
 * Adds configurable delay to mega menu closing behavior
 */

(function() {
  class MegaMenuDelayHandler {
    constructor() {
      this.headerWrapper = null;
      this.closeDelay = 0;
      this.clickToClose = false;
      this.closeTimeout = null;
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.enhanceMenuBehavior());
      } else {
        this.enhanceMenuBehavior();
      }
    }

    enhanceMenuBehavior() {
      // Get the header wrapper to read settings
      this.headerWrapper = document.querySelector('[data-header-wrapper]');
      
      if (!this.headerWrapper) {
        console.warn('Header wrapper not found');
        return;
      }

      // Read settings from data attributes
      this.closeDelay = parseInt(this.headerWrapper.getAttribute('data-menu-close-delay') || '0');
      this.clickToClose = this.headerWrapper.getAttribute('data-menu-click-to-close') === 'true';

      const hoverDisclosures = document.querySelectorAll('hover-disclosure');
      
      if (hoverDisclosures.length === 0) {
        return;
      }

      // If click-to-close mode is enabled, set up document click handler once
      if (this.clickToClose) {
        this.setupClickToClose(hoverDisclosures);
      } else {
        this.setupDelayedClose(hoverDisclosures);
      }
    }

    setupDelayedClose(disclosures) {
      disclosures.forEach(disclosure => {
        // Store original methods if not already stored
        if (!disclosure._megaMenuEnhanced) {
          disclosure._megaMenuEnhanced = true;
          disclosure._originalHideDisclosure = disclosure.hideDisclosure.bind(disclosure);
          disclosure._originalShowDisclosure = disclosure.showDisclosure.bind(disclosure);

          // Override the hideDisclosure method to add delay
          disclosure.hideDisclosure = () => {
            if (disclosure._closeTimeout) {
              clearTimeout(disclosure._closeTimeout);
            }
            
            if (this.closeDelay > 0) {
              disclosure._closeTimeout = setTimeout(() => {
                disclosure._originalHideDisclosure();
              }, this.closeDelay);
            } else {
              disclosure._originalHideDisclosure();
            }
          };

          // Override showDisclosure to cancel any pending close
          disclosure.showDisclosure = function(e) {
            if (disclosure._closeTimeout) {
              clearTimeout(disclosure._closeTimeout);
            }
            disclosure._originalShowDisclosure(e);
          };
        }
      });
    }

    setupClickToClose(disclosures) {
      disclosures.forEach(disclosure => {
        if (!disclosure._megaMenuEnhanced) {
          disclosure._megaMenuEnhanced = true;
          
          // Store original methods
          disclosure._originalHideDisclosure = disclosure.hideDisclosure.bind(disclosure);
          disclosure._originalShowDisclosure = disclosure.showDisclosure.bind(disclosure);

          // Override hideDisclosure to prevent closing on mouseleave
          disclosure.hideDisclosure = function() {
            // Do nothing - menu will only close on outside click
          };

          // Keep the show functionality
          disclosure.showDisclosure = disclosure._originalShowDisclosure;
        }
      });

      // Add single document click handler for all menus
      document.addEventListener('click', (e) => {
        disclosures.forEach(disclosure => {
          const isClickInside = disclosure.contains(e.target);
          const isOpen = disclosure.classList.contains('is-visible');
          const dropdown = disclosure.querySelector('.header__dropdown');
          const isClickInDropdown = dropdown && dropdown.contains(e.target);
          
          // Close if clicking outside the disclosure and dropdown
          if (!isClickInside && !isClickInDropdown && isOpen) {
            if (disclosure._originalHideDisclosure) {
              disclosure._originalHideDisclosure();
            }
          }
        });
      }, true);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MegaMenuDelayHandler());
  } else {
    new MegaMenuDelayHandler();
  }
})();

